import { Snackbar, Switch, FormControlLabel } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { SnackbarWrapper } from "../../Snackbar/SnackbarWrapper";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { Formik, Form } from "formik";
import axios from "axios";

export function SchedulerSettings() {
  const [schedulerEnabled, setSchedulerEnabled] = useState(false);
  const [successOpen, setSuccessOpen] = useState(false);
  const [errorOpen, setErrorOpen] = useState(false);

  const branch = useSelector(
    (state) => state.auth.branches.currentBranch,
    shallowEqual
  );

  useEffect(() => {
    const getSetting = async () => {
      const result = await axios(
        "api/branches/scheduler/view/" + branch.branch_id
      );
      setSchedulerEnabled(!!result.data.scheduler_enabled_ind);
    };

    branch && getSetting();
  }, [branch]);

  const handleClose = () => {
    setSuccessOpen(false);
    setErrorOpen(false);
  };

  const saveSetting = async (values) => {
    const result = await axios.patch("api/branches/scheduler/view/", {
      branch_id: branch.branch_id,
      scheduler_enabled_ind: values.scheduler_enabled_ind ? 1 : 0,
    });
    if (result.data === "success") {
      setSchedulerEnabled(!!values.scheduler_enabled_ind);
      setSuccessOpen(true);
    } else {
      setErrorOpen(true);
    }
  };

  return (
    <>
      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={successOpen ? successOpen : errorOpen}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <SnackbarWrapper
          onClose={handleClose}
          variant={successOpen ? "success" : "error"}
          message={
            successOpen ? "Scheduler setting saved" : "Something went wrong"
          }
        />
      </Snackbar>
      <Card>
        <CardHeader title="Trial Scheduler">
          <CardHeaderToolbar></CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Formik
            enableReinitialize
            initialValues={{ scheduler_enabled_ind: schedulerEnabled }}
            onSubmit={saveSetting}
          >
            {({ values, setFieldValue, handleSubmit }) => (
              <Form>
                <FormControlLabel
                  control={
                    <Switch
                      checked={!!values.scheduler_enabled_ind}
                      onChange={(e) =>
                        setFieldValue(
                          "scheduler_enabled_ind",
                          e.target.checked
                        )
                      }
                      color="primary"
                    />
                  }
                  label="Allow customers to choose their own trial date and time on the website"
                />
                <p className="text-muted">
                  When enabled, the trial request form on the website shows a
                  "Choose my trial date and time" option that lets families
                  self-schedule a trial slot. When disabled, families are
                  contacted by staff to schedule instead.
                </p>
                <button
                  type="submit"
                  className="btn btn-primary"
                  onClick={handleSubmit}
                >
                  Save
                </button>
              </Form>
            )}
          </Formik>
        </CardBody>
      </Card>
    </>
  );
}
